module.exports = __webpack_public_path__ + "static/media/48278050_2308765242531987_199591201874116608_o-thumb.5e484289.jpg";